export interface FitterVehicle {
  id: string;
  name: string;
  licensePlateNumber: string;
  manufacturer: string;
  model: string;
  active: boolean;
}
